export default __webpack_public_path__ + "static/media/charter-booking-tours.31bbfcad.png";